<template>
  <!-- prettier-ignore -->
  <div
    class="toggle"
    :class="classes">
    <div>
      <input
        :id="uid"
        class="toggle__input"
        type="checkbox"
        :name="name"
        :checked="$props.modelValue"
        :value="$props.modelValue"
        :true-value="true"
        :false-value="false"
        @change="emitUpdate"
      />
      <label
        class="toggle__label"
        :for="uid"
      />
    </div>

    <label :for="uid">
      <slot>
        {{ title }}
      </slot>
    </label>
  </div>
</template>

<script setup>
import { v4 as uuidv4 } from 'uuid'
import { computed } from 'vue'

const emit = defineEmits(['update:modelValue'])

// Props
const props = defineProps({
  color: {
    type: [String, Object],
    default() {
      return '#5bac26'
    },
  },

  height: {
    type: Number,
    default: 20,
  },

  modelValue: {
    type: Boolean,
  },

  name: {
    type: String,
    required: true,
  },

  readonly: {
    type: Boolean,
    default: false,
  },

  title: {
    type: String,
    default: '',
  },

  validate: {
    type: Object,
    default: () => {},
  },

  width: {
    type: Number,
    default: 35,
  },
})

// Data
const uid = uuidv4()

// Computeds
const classes = computed(() => {
  return {
    'toggle--readonly': props.readonly,
    'toggle--invalid': props.validate?.$invalid && props.validate?.$error,
  }
})

// Methods
function emitUpdate() {
  props.validate?.$touch()

  emit('update:modelValue', !props.modelValue)
}
</script>

<style name="mobile" scoped>
.toggle {
  display: flex;
  flex-direction: row;
  gap: 8px;
  font-size: 15px;

  .toggle__input {
    position: absolute;
    height: 0;
    width: 0;
    visibility: hidden;

    &:checked + label {
      background: var(--c-original-green);
    }

    &:checked + .toggle__label:after {
      left: calc(100% - 5px);
      transform: translateX(-100%);
    }
  }

  .toggle__label {
    cursor: pointer;
    text-indent: -9999px;
    width: 35px;
    height: 20px;
    background: var(--c-gray);
    display: block;
    border-radius: 100px;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      top: 4px;
      left: 2.5px;
      width: 12px;
      height: 12px;
      background: var(--c-white);
      border-radius: 90px;
    }
  }

  &--invalid {
    .toggle__label {
      background-color: var(--c-error-lighten-15);

      &:after {
        background: var(--c-error);
      }
    }
  }

  &--readonly {
    pointer-events: none;
  }
}
</style>
